import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';

@Component({
  selector: 'app-job-reorder',
  templateUrl: './job-reorder.component.html',
  styleUrls: ['./job-reorder.component.scss']
})
export class JobReorderComponent implements OnInit, OnChanges {
  @Input() jobs: any[];
  @Input() routeDetails: any;
  @Input() canRemove?: boolean = true;
  @Input() showRouteAlert?: boolean = false;
  @Input() timezone?: string;
  @Output() reorderChange: EventEmitter<any> = new EventEmitter();

  preference: any;
  dateTimeFormat: string;

  constructor(
    private _localStorageService: LocalStorageService,
    private utilityService: UtilityService,
  ) { }

  drop(event: CdkDragDrop<unknown>): void {
    moveItemInArray(this.jobs, event.previousIndex, event.currentIndex);
    this.reorderChange.emit(this.jobs);
  }

  removeJob(index: number): void {
    this.jobs.splice(index, 1);
    this.reorderChange.emit(this.jobs);
  }

  getJobCustomerAddress(jobDetails: any): string {
    return _.compact([jobDetails?.customer_address?.street,
    jobDetails?.customer_address?.landmark,
    jobDetails?.customer_address?.city || jobDetails?.customer_address?.name,
    jobDetails?.customer_address?.state,
    jobDetails?.customer_address?.zip_code,
    jobDetails?.customer_address?.country
  ]).join(', ');
  }

  ngOnInit(): void {
    this.preference = this._localStorageService.getLocalStorage('dispatch_board_metadata');
    this.dateTimeFormat = this.utilityService.dateTimeFormat;

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('jobs' in changes) {
      this.jobs = changes.jobs.currentValue;
    }
  }

}
